import { jsx, jsxs } from 'react/jsx-runtime';
import { ThemeProvider, CssBaseline } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { Router } from 'react-router-dom';
import { setCookie, getCookie } from 'typescript-cookie';
import { o as oidc_1, d as dist } from './index-d8f55c20.js';
import { a4 as historyRef, Z as IdleTimer, U as LayoutWrapperContext, W as Routes } from './AccountTreeList-58ce8378.js';
import 'lodash';
import './baseAccount-863ddd48.js';
import 'react-redux';
import './_tslib-ff3a08af.js';
import './Prompt-bf2f8ed4.js';
import './userProfileSelectors-33b20ef0.js';
import '@react-google-maps/api';
import 'react-dom/server';
import { b as StyleConstantsProvider } from './globalButtonStyles-41c8af84.js';
import '@material-ui/lab/Autocomplete';
import './SearchInput-9fbcf52e.js';
import 'react-select/async';
import '@material-ui/core/SvgIcon';
import './ClearIndicator-e1d121b8.js';
import 'react-select/async-creatable';
import 'react-select';
import './CustomSelect-aeddb5fe.js';
import '@material-ui/icons/ChevronLeft';
import '@material-ui/icons/ChevronRight';
import '@material-ui/icons';
import './LoadingData-d24d8384.js';
import './Button-3cc41ab2.js';
import './CustomInput-7f72fe33.js';
import './Gallery-4ad7f646.js';
import './InformationTooltip-7059c75f.js';
import '@material-ui/icons/MenuRounded';
import './NotFound.styles-db4376d0.js';
import './LabeledValue-35614cb5.js';
import '@material-ui/icons/Star';
import './SelectableStar.styles-90bbef1f.js';
import '@reduxjs/toolkit';
import { L as LoadingComponent } from './Loading-66d0b8d4.js';
import { R as RedirectWrapper } from './RedirectWrapper-02b4b722.js';

var logout = function (sessionConfig) {
    var oidc = oidc_1.Oidc.get();
    setCookie(sessionCookie, Date.now(), {
        path: '/',
        domain: sessionConfig.sessionCookieDomain,
        secure: sessionConfig.sessionCookieIsSecure,
        sameSite: 'none'
    });
    if (oidc) {
        oidc.logoutAsync(window.location.origin);
    }
};

// NOTE: when server side rendering will be required please omit usage of window
var getConfiguration = function (additionalConfig) {
    var _a;
    return {
        client_id: (additionalConfig === null || additionalConfig === void 0 ? void 0 : additionalConfig.clientId) || process.env.REACT_APP_IS_CLIENT,
        redirect_uri: window.location.origin + '/authentication/login-callback/',
        scope: (additionalConfig === null || additionalConfig === void 0 ? void 0 : additionalConfig.scope) || process.env.REACT_APP_IS_SCOPE,
        authority: (additionalConfig === null || additionalConfig === void 0 ? void 0 : additionalConfig.authority) || process.env.REACT_APP_IS_URL,
        silent_login_timeout: (_a = additionalConfig === null || additionalConfig === void 0 ? void 0 : additionalConfig.silentLoginTimeout) !== null && _a !== void 0 ? _a : 12000,
        silent_redirect_uri: window.location.origin + '/authentication/silent_callback',
        service_worker_only: false,
        token_renew_mode: dist.TokenRenewMode.access_token_invalid
    };
};
var OidcProvider = function (_a) {
    var children = _a.children,
        additionalConfig = _a.additionalConfig,
        sessionConfig = _a.sessionConfig,
        authenticatingComponent = _a.authenticatingComponent,
        authenticatingErrorComponent = _a.authenticatingErrorComponent,
        callbackSuccessComponent = _a.callbackSuccessComponent,
        loadingComponent = _a.loadingComponent,
        sessionLostComponent = _a.sessionLostComponent;
    var configuration = getConfiguration(additionalConfig);
    var withCustomHistory = function () {
        return {
            replaceState: function (url) {
                historyRef.replace({
                    pathname: url
                });
                window.dispatchEvent(new Event('popstate'));
            }
        };
    };
    return jsx(dist.OidcProvider, { configuration: configuration, authenticatingComponent: authenticatingComponent !== null && authenticatingComponent !== void 0 ? authenticatingComponent : function () {
            return LoadingComponent({ caption: 'Authentication in progress...' });
        }, withCustomHistory: withCustomHistory, authenticatingErrorComponent: authenticatingErrorComponent !== null && authenticatingErrorComponent !== void 0 ? authenticatingErrorComponent : function () {
            return RedirectWrapper({ url: '/' });
        }, onEvent: function (_, name) {
            if (name === oidc_1.Oidc.eventNames.loginCallbackAsync_error || name === oidc_1.Oidc.eventNames.silentLoginAsync_error || name === oidc_1.Oidc.eventNames.logout_from_another_tab) {
                setCookie(sessionCookie, Date.now(), {
                    path: '/',
                    domain: sessionConfig.sessionCookieDomain,
                    secure: sessionConfig.sessionCookieIsSecure,
                    sameSite: 'none'
                });
            }
        }, callbackSuccessComponent: callbackSuccessComponent !== null && callbackSuccessComponent !== void 0 ? callbackSuccessComponent : function () {
            return RedirectWrapper({ url: '/' });
        }, sessionLostComponent: sessionLostComponent !== null && sessionLostComponent !== void 0 ? sessionLostComponent : function () {
            return RedirectWrapper({ url: '/' });
        }, loadingComponent: loadingComponent !== null && loadingComponent !== void 0 ? loadingComponent : LoadingComponent, onSessionLost: function () {
            return logout(sessionConfig);
        }, children: children });
};

var useAuth = function (setOidcUser) {
    var _a, _b, _c;
    var _d = (_a = dist.useOidcUser()) !== null && _a !== void 0 ? _a : {},
        oidcUserLoadingState = _d.oidcUserLoadingState,
        oidcUser = _d.oidcUser;
    var accessToken = ((_b = dist.useOidcAccessToken()) !== null && _b !== void 0 ? _b : {}).accessToken;
    var idToken = ((_c = dist.useOidcIdToken()) !== null && _c !== void 0 ? _c : {}).idToken;
    useEffect(function () {
        if (oidcUserLoadingState === dist.OidcUserStatus.Loaded && !!oidcUser) {
            setOidcUser({ user: oidcUser, isLoadingUser: false });
        }
    }, [oidcUserLoadingState, oidcUser]);
    useEffect(function () {
        idToken && setOidcUser({ idToken: idToken });
    }, [idToken]);
    useEffect(function () {
        accessToken && setOidcUser({ accessToken: accessToken });
    }, [accessToken]);
};

var sessionCookie = 'hwm-session-expiration';
function AppWrapper(_a) {
    var LazyLayout = _a.LazyLayout,
        applicationPaths = _a.applicationPaths,
        initialLayoutProps = _a.initialLayoutProps,
        redirectEmptyUrl = _a.redirectEmptyUrl,
        setOidcUser = _a.setOidcUser;
    useAuth(setOidcUser);
    var _b = useState(initialLayoutProps),
        layoutProps = _b[0],
        setLayoutProps = _b[1];
    useEffect(function () {
        var _a;
        if (initialLayoutProps === null || initialLayoutProps === void 0 ? void 0 : initialLayoutProps.disableIdleTimer) {
            return function () {};
        }
        var idleTimer = new IdleTimer({
            timeout: (_a = initialLayoutProps.sessionConfig.sessionIdleTimeout) !== null && _a !== void 0 ? _a : 3600,
            onTimeout: function () {
                return logout(initialLayoutProps.sessionConfig);
            },
            onGetSessionExpire: function () {
                var _a;
                var cookieValue = (_a = getCookie(sessionCookie)) !== null && _a !== void 0 ? _a : '0';
                return Number(cookieValue);
            },
            onUpdateSessionExpire: function (expire) {
                setCookie(sessionCookie, expire, {
                    path: '/',
                    domain: initialLayoutProps.sessionConfig.sessionCookieDomain,
                    secure: initialLayoutProps.sessionConfig.sessionCookieIsSecure,
                    sameSite: 'none'
                });
            }
        });
        return function () {
            idleTimer.cleanUp();
        };
    }, []);
    return jsx(LayoutWrapperContext.Provider, { value: {
            props: layoutProps,
            setProps: setLayoutProps
        }, children: Routes(applicationPaths, LazyLayout, layoutProps, redirectEmptyUrl) });
}
function AppInit(_a) {
    var LazyLayout = _a.LazyLayout,
        applicationPaths = _a.applicationPaths,
        initialLayoutProps = _a.initialLayoutProps,
        styleConstants = _a.styleConstants,
        theme = _a.theme,
        redirectEmptyUrl = _a.redirectEmptyUrl,
        additionalConfig = _a.additionalConfig,
        setOidcUser = _a.setOidcUser;
    return jsx(StyleConstantsProvider, { constants: styleConstants, children: jsxs(ThemeProvider, { theme: theme, children: [jsx(CssBaseline, {}), jsx(OidcProvider, { additionalConfig: additionalConfig, sessionConfig: initialLayoutProps.sessionConfig, children: jsx(Router, { history: historyRef, children: jsx(AppWrapper, { applicationPaths: applicationPaths, initialLayoutProps: initialLayoutProps, LazyLayout: LazyLayout, redirectEmptyUrl: redirectEmptyUrl, setOidcUser: setOidcUser }) }) })] }) });
}

export { AppInit as A, OidcProvider as O, getConfiguration as g, logout as l, sessionCookie as s };
